import * as React from "react";
import { createPortal } from "react-dom";
export class ContentPortal extends React.Component {
    constructor() {
        super(...arguments);
        this.portalNode = null;
        this.rootNode = document.getElementById("revo-content") || document.body;
    }
    componentWillUnmount() {
        if (this.portalNode) {
            this.rootNode && this.rootNode.removeChild(this.portalNode);
        }
        this.portalNode = null;
    }
    render() {
        if (!this.portalNode) {
            this.portalNode = document.createElement("div");
            this.rootNode && this.rootNode.appendChild(this.portalNode);
        }
        return createPortal(this.props.children, this.portalNode);
    }
}
export default ContentPortal;
//# sourceMappingURL=contentportal.js.map